import React from "react";
import { Button } from "react-bootstrap";

const ConfirmDeletion = ({ onClickYes, onClickNo }) => {
  return (
    <div className="confirm-deletion-box">
      <div className="sure-text">Sicher?</div>
      <Button className="btn btn-secondary" onClick={onClickNo}>
        Nein
      </Button>
      <Button
        bsStyle="danger"
        className="delete-order-unit"
        onClick={onClickYes}
      >
        Ja
      </Button>
    </div>
  );
};

export default ConfirmDeletion;
